import { Conf2SpecialJwt, Conf2StreamName } from "@common/domain";
import { getSelectors, RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CONF2_QUERY_PARAMS } from "@youm-front/conf2/domain";

const selectRouter = createFeatureSelector<RouterReducerState>("router");
const { selectQueryParams } = getSelectors(selectRouter);

export const conf2JwtQueryParam = createSelector(selectQueryParams, (_) => {
  return _?.[CONF2_QUERY_PARAMS.jwt] as undefined | Conf2SpecialJwt;
});
export const conf2StreamNameQueryParam = createSelector(
  selectQueryParams,
  (_) => {
    return _?.[CONF2_QUERY_PARAMS.streamName] as undefined | Conf2StreamName;
  }
);
